import { render, staticRenderFns } from "./cardAllPondsTable.vue?vue&type=template&id=5cf605fe&"
import script from "./cardAllPondsTable.vue?vue&type=script&lang=js&"
export * from "./cardAllPondsTable.vue?vue&type=script&lang=js&"
import style0 from "./cardAllPondsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports